/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportChargebackInfoRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {ReportChargebackInfoResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const reportChargebackInfo = (request: ReportChargebackInfoRequest, options?: CashRequestOptions) => post<ReportChargebackInfoRequest, ReportChargebackInfoResponse>("/2.0/cash/report-chargeback-info", request, {...options, rejectOnError: true })